import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'kh-app-text-button',
    templateUrl: './app-text-button.component.html',
    styleUrls: ['./app-text-button.component.scss'],
    // See app-flat-button.component.ts for why the host carries `mat-mdc-button-base`.
    host: {
        'class': 'mat-mdc-button-base'
    },
    imports: [
        MatButton,
        MatIcon,
    ],
})
export class AppTextButtonComponent {
    @Output() clicked = new EventEmitter<MouseEvent>();

    @Input() disabled = false;
    @Input() icon: string | undefined;
    @Input() iconRight: string | undefined;
    @Input() type: 'button' | 'submit' | 'reset' = 'button';

    click(event: MouseEvent): void {
        if (this.disabled) {
            return;
        }
        this.clicked.emit(event);
    }
}
